export default [
  {
    address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
    symbol: "AAVE",
  },
  {
    address: "0x3de27efa2f1aa663ae5d458857e731c129069f29",
    symbol: "ABPTV2",
  },
  {
    address: "0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f",
    symbol: "GHO",
  },
] as const
